import { useEffect, useState } from "react";
import { ArrowLeftRight, Search, MapPin, CalendarDays } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "@/components/ui/select";
import { api } from "@/lib/api";
import { todayStr } from "@/lib/format";

export function useStations() {
  const [stations, setStations] = useState([]);
  useEffect(() => { api.get("/public/stations").then((r) => setStations(r.data)); }, []);
  return stations;
}

const StationSelect = ({ value, onChange, stations, placeholder, testid }) => (
  <Select value={value || ""} onValueChange={onChange}>
    <SelectTrigger className="h-12 border-0 bg-transparent px-0 text-base font-bold shadow-none focus:ring-0" data-testid={testid}>
      <SelectValue placeholder={placeholder} />
    </SelectTrigger>
    <SelectContent>
      {stations.map((s) => (
        <SelectItem key={s.id} value={s.id} data-testid={`${testid}-option-${s.code}`}>{s.city} <span className="text-slate-400">· {s.name}</span></SelectItem>
      ))}
    </SelectContent>
  </Select>
);

export default function SearchForm({ initial = {}, onSearch }) {
  const stations = useStations();
  const [from, setFrom] = useState(initial.from || "");
  const [to, setTo] = useState(initial.to || "");
  const [date, setDate] = useState(initial.date || todayStr());
  const ok = from && to && from !== to;

  return (
    <form onSubmit={(e) => { e.preventDefault(); ok && onSearch({ from, to, date }); }}
      className="card-soft grid grid-cols-1 gap-0 p-2 md:grid-cols-[1fr_auto_1fr_200px_auto] md:items-center" data-testid="search-form">
      <div className="rounded-xl px-4 py-2 hover:bg-slate-50">
        <div className="label-xs flex items-center gap-1"><MapPin className="h-3 w-3 text-[#0052FF]" />From</div>
        <StationSelect value={from} onChange={setFrom} stations={stations} placeholder="Leaving from" testid="search-from-select" />
      </div>
      <button type="button" onClick={() => { setFrom(to); setTo(from); }} className="btn-press mx-auto -my-3 z-10 grid h-10 w-10 place-items-center rounded-full border border-slate-200 bg-white text-[#0052FF] shadow-sm hover:rotate-180 transition-transform md:my-0" data-testid="search-swap-button" aria-label="Swap">
        <ArrowLeftRight className="h-4 w-4" />
      </button>
      <div className="rounded-xl px-4 py-2 hover:bg-slate-50">
        <div className="label-xs flex items-center gap-1"><MapPin className="h-3 w-3 text-sky-500" />To</div>
        <StationSelect value={to} onChange={setTo} stations={stations.filter((s) => s.id !== from)} placeholder="Going to" testid="search-to-select" />
      </div>
      <div className="rounded-xl px-4 py-2 hover:bg-slate-50 md:border-l md:border-slate-100">
        <div className="label-xs flex items-center gap-1"><CalendarDays className="h-3 w-3 text-[#0052FF]" />Travel date</div>
        <input type="date" min={todayStr()} value={date} onChange={(e) => setDate(e.target.value)} className="h-12 w-full bg-transparent text-base font-bold outline-none" data-testid="search-date-input" />
      </div>
      <Button type="submit" disabled={!ok} className="m-1 h-14 rounded-xl bg-[#0052FF] px-7 text-base font-bold hover:bg-[#0041CC] btn-press" data-testid="search-submit-button">
        <Search className="h-5 w-5" /> Find buses
      </Button>
    </form>
  );
}
